export const detailScreenModeEnum = {
  detail: 1,
  create: 2, 
  update: 3
}